import {snakeCase} from 'lodash';
import axiosWithAuth from '@/utils/axiosWithAuth';
import mapKeysToCase from '@/utils/mapKeysToCase';
import {
  CreatorSearchResult,
  PagingParams,
  MultiPlatformFilter,
  Sorting,
} from '@/types/models/creator-crm/creatorCrm';
import QueryContext from '@/api/QueryContext';

const SEARCH_CREATORS_PATH = 'creators/search';

// eslint-disable-next-line @typescript-eslint/naming-convention
export type RequestType = 'multiplatform';

export type CreatorsSearchStartSessionRequest = {
  type: RequestType;
  query: MultiPlatformFilter;
  sort?: Sorting;
  page_size: number;
  crm?: boolean;
};

export type CreatorsSearchResponse = {
  creators: CreatorSearchResult[];
  pagingParams: PagingParams;
  searchSessionId?: string;
  loadedPages: number;
};

const searchCreatorsFetchers = {
  startSearchSession: async (context: QueryContext) => {
    if (!context.meta) throw Error('invalid query context meta');
    const brandId = context.meta.brandId as string | undefined;
    if (!brandId) throw new Error('brand_id is required');
    const query = context.meta.query as MultiPlatformFilter;
    const searchRequestBody: CreatorsSearchStartSessionRequest = {
      type: context.meta.type as RequestType,
      query: mapKeysToCase(query, snakeCase) as MultiPlatformFilter,
      sort: context.meta.sort ? (context.meta.sort as Sorting) : undefined,
      page_size: context.meta.itemsPerPage as number,
      crm: context.meta.crm !== false,
    };
    const result = await axiosWithAuth.post<CreatorsSearchResponse>(
      SEARCH_CREATORS_PATH,
      searchRequestBody,
      {
        params: {
          brand_id: brandId,
        },
      }
    );
    return result.data;
  },
  changePage: async (context: QueryContext) => {
    if (!context.meta) throw Error('invalid query context meta');
    const page = context.pageParam as number;
    const sessionId = context.meta.sessionId as string;
    const result = await axiosWithAuth.get<CreatorsSearchResponse>(
      `${SEARCH_CREATORS_PATH}/${sessionId}`,
      {
        params: {
          page,
        },
      }
    );
    return result.data;
  },
};

export default searchCreatorsFetchers;
